
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Tscheme',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Tscheme.vue